import { useEffect, useState } from 'react';
import { LoaderCircle } from 'lucide-react';

export type LoadingTextProps = {
  isLoading: boolean;
  descriptions?: string[];
};

export function LoadingText({
  descriptions = ['Loading...'],
  isLoading,
}: LoadingTextProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isLoading || descriptions.length <= 1) return;

    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % descriptions.length);
    }, 4_000);

    return () => clearInterval(intervalId);
  }, [isLoading, descriptions]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 text-primary-400">
      <LoaderCircle className="size-6 animate-spin text-primary-300 [animation-duration:2s]" />
      <span className="inline-flex animate-pulse">
        {descriptions[currentIndex]}
      </span>
    </div>
  );
}
